import {
  Link as RouterLink,
  type LinkProps as RouterLinkProps,
} from 'react-router-dom';
import type { AnchorHTMLAttributes, ReactNode } from 'react';

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  href: string;
  children?: ReactNode;
  replace?: boolean;
  prefetch?: boolean;
  scroll?: boolean;
};

/** Vite SPA 对 `next/link` 的 shim。 */
export default function Link({
  href,
  children,
  replace,
  prefetch: _prefetch,
  scroll: _scroll,
  ...rest
}: Props) {
  return (
    <RouterLink to={href} replace={replace} {...(rest as Omit<RouterLinkProps, 'to'>)}>
      {children}
    </RouterLink>
  );
}
